const hostname = (window.location.hostname || "").toLowerCase();

const LOCAL_API_ORIGIN = "http://localhost:52476";
const LEGACY_API_ORIGIN = "https://djpsmbdapi.jueducation.com";
const NEW_API_ORIGIN = "https://myapi.djpsmbdin.edu.pk";

const NEW_FRONTEND_HOSTS = new Set([
  "my.djpsmbdin.edu.pk",
]);

function isLocalhost(host) {
  return host === "localhost" || host === "127.0.0.1";
}

function isLegacyFrontend(host) {
  return host.includes("jueducation");
}

function isNewFrontend(host) {
  if (NEW_FRONTEND_HOSTS.has(host)) {
    return true;
  }

  // Any other djpsmbdin.edu.pk frontend subdomain (except the API host)
  return host.endsWith(".djpsmbdin.edu.pk") && host !== "myapi.djpsmbdin.edu.pk";
}

function resolveApiOrigin(host) {
  if (isLocalhost(host)) {
    return LOCAL_API_ORIGIN;
  }

  if (isNewFrontend(host)) {
    return NEW_API_ORIGIN;
  }

  if (isLegacyFrontend(host)) {
    return LEGACY_API_ORIGIN;
  }

  // Unknown host: keep legacy API during parallel rollout.
  return LEGACY_API_ORIGIN;
}

function buildUrls(apiOrigin) {
  const origin = apiOrigin.replace(/\/$/, "");

  return {
    base_url: `${origin}/api/`,
    StaffImagePath: `${origin}/staff_images/`,
    StudentImagePath: `${origin}/student_images/`,
    images: `${origin}/images/`,
    assets: `${origin}/assets/`,
    root: `${origin}/`,
  };
}

const urls = buildUrls(resolveApiOrigin(hostname));

const config = {
  ...urls,
  path: undefined,
  admin_path: undefined,
  date_format: "DD/MM/YYYY",
  date_format_input: "YYYY-MM-DD",
};

export default config;
